import React from 'react';
import Step from "./Step";
import cx from 'classnames';
var css = {
  "horizontal": "oalp-pSEeR",
  "vertical": "oalp-3EEqa",
  "horizontalStep": "oalp-1zSF1",
  "subTitle": "oalp-1c6F2",
  "title": "oalp-3oBe1",
  "stepLabel": "oalp-2jfXZ",
  "stepSubLabel": "oalp-2siwT",
  "bullet": "oalp-1LEtZ",
  "progressLine": "oalp-1810i",
  "bulletTR": "oalp-2owFA",
  "last": "oalp-2KUSD",
  "progressLineTR": "oalp-2xpdR",
  "active": "oalp-2B4Oy",
  "horizontalStepWrapper": "oalp-I1OOG",
  "horizontalStepLeft": "oalp-1GdEB",
  "horizontalStepRight": "oalp-2UpUE"
};
var StepProgress = function StepProgress(_ref) {
  var steps = _ref.data.steps,
    metadata = _ref.metadata;
  var _ref2 = metadata || {},
    widgetStyle = _ref2.style,
    alignment = _ref2.alignment;
  if (steps && steps.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cx(alignment === 'horizontal' ? css.horizontal : css.vertical),
    style: widgetStyle
  }, /*#__PURE__*/React.createElement("ul", null, steps.map(function (step, idx) {
    return /*#__PURE__*/React.createElement("li", {
      key: "step-".concat(idx)
    }, /*#__PURE__*/React.createElement(Step, {
      step: step,
      alignment: alignment,
      isLast: idx + 1 === steps.length
    }));
  })));
};
export default StepProgress;